import { useEffect } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import posthog from 'posthog-js';

import { Routes } from '@/config/Routes';

export const Route = createFileRoute('/logout')({
	component: LogoutPage,
});

function LogoutPage() {
	const queryClient = useQueryClient();
	const navigate = useNavigate();

	useEffect(() => {
		if (posthog.__loaded) {
			posthog.reset();
		}
		queryClient.clear();
		navigate({ to: Routes.LOGIN });
	}, [queryClient, navigate]);

	return null;
}
